import React from 'react';
import './FacePreview.scss';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { faImage, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';


class FacePreview extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            popUpObjects: {},
            requiredObj: {},
            data: [],
            canvasElemet1: React.createRef(),
            canvasElemet2: React.createRef(),
            imageRef: React.createRef()
        }
    }

    getBodyClasses = () => "custom-body custom-mt10";

    fillText = (ctx, box, subjects) => {
        ctx.font = "10px Arial";
        ctx.fillStyle = "#0FFF50";
        if (subjects && subjects.length) {
            let text = subjects.map(item => item.subject).join(", ");
            ctx.fillText(text, box.x_min, box.y_min - 5);
        }
    }

    drawFace = (ctx, faceData) => {
        let box = faceData.box;
        let subjects = faceData.subjects;
        ctx.strokeStyle = "#0FFF50";
        ctx.lineWidth = 2;
        ctx.strokeRect(box.x_min, box.y_min, box.x_max - box.x_min, box.y_max - box.y_min);
        this.fillText(ctx, box, subjects);
    }

    drawImage = () => {
        const { faceRecognize } = this.props.faceObjects;
        const { data } = faceRecognize;
        if (data && data[0] && data[0].box) {
            const c = document.getElementById("canvas_first");
            const ctx1 = c.getContext("2d");
            const img = document.getElementById("previewImage");
            ctx1.drawImage(img, 0, 0);
            this.drawBox();
        }
    }

    drawBox = () => {
        const { faceRecognize } = this.props.faceObjects;
        const { data } = faceRecognize;
        let ctx = this.state.canvasElemet2.current.getContext('2d');

        if (data && data.length) {
            data.forEach(item => {
                this.drawFace(ctx, item);
            });
        }
    }

    initData = () => {
        setTimeout(() => this.drawBox(), 100);
    }

    onCloseBtnClick = () => {
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { showOverlay: false },
            showPreview: false
        });
        if (this.props.cancelCallback) this.props.cancelCallback();
    }


    showHeader = () => {
        return (
            <div className="custom-previewheader">
                <div className="custom-icontop" onClick={this.onCloseBtnClick}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </div>)
    }

    showBody = () => {
        if (this.props.previewSrc)
            return (
                <div className={this.getBodyClasses()}>
                    <div className="custom-img-wrapper">
                        <div className="custom-previewimg">
                            <img src={this.props.previewSrc} id="previewImage" />
                        </div>
                        <canvas className="custom-canvas" ref={this.state.canvasElemet2}
                            width={this.props.previewWidth} height={this.props.previewHeight}>
                        </canvas>
                        <div>

                        </div>
                    </div>
                </div>)
        return null;
    }


    componentDidUpdate(prev) {
        const { faceRecognize } = this.props.faceObjects;
        if (!prev.faceObjects.faceRecognize.showOverlay && faceRecognize.showOverlay) {
            this.initData();
        }
    }

    componentDidMount() {
        console.log("LOGS: LAMTEST this.props.clip", this.props.clip);
        this.initData();
    }

    componentWillUnmount() {
        this.onCloseBtnClick();
    }

    showFooter = () => {
        return (
            <div className="custom-footer" >
                <FontAwesomeIcon icon={faImage} />
            </div>)
    }

    render() {
        if (this.props.mainObj[`${this.props.subObjName}`].showOverlay && this.props.previewSrc)
            return (
                <div className="FacePreview">
                    <div className="custom-overlay">
                        <div className="custom-preview">
                            {this.props.loading ? <div className="custom-spinner-overlay"><Spinner /></div> : <div />}
                            {this.showHeader()}
                            {this.showBody()}
                        </div>
                    </div>
                </div>
            );
        return null;
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    clip: state.clip.currentClip,

})
const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FacePreview));